// extracted by mini-css-extract-plugin
export var boxItems = "_98-1";
export var boxItemsLg = "_98-2";
export var button = "_98-7";
export var buttonHoverless = "_98-9";
export var buttonLg = "_98-8";
export var filterGroupBox = "_98-0";
export var icon = "_98-3";
export var iconSecondary = "_98-6";
export var iconWrapper = "_98-4";
export var iconWrapperLg = "_98-5";
export var truncatedLabel = "_98-a";